import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { RemoveRedEye, ReplayCircleFilledOutlined } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import {
  obtApproveReject,
  getOBTApplyList,
  getOBTQuestionAnswer,
  getOBTRejectReason
} from "src/api/commonapi";
import Label from "src/components/Label";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Routes } from "src/constant/api_url";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import moment from "moment";

export default function OBTApply() {
  const obtDetailModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const QuestionAnswerModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const renderStars = (rating) => {
    const maxStars = 5;
    const filledStars = "★".repeat(Math.round(rating)); // Filled stars
    const emptyStars = "☆".repeat(maxStars - Math.round(rating)); // Empty stars

    return <span style={{ color: "gold", fontSize: "16px" }}>{filledStars + emptyStars}</span>;
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();

  const obtApproveRejectOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Rejected", value: 1 },
    { label: "Approved", value: 2 }
  ];

  const memberRatings = [
    { label: "All", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 }
  ];

  const [rejectReason, setRejectReason] = useState({ id: "", title: "" });
  const [obtRejectReasonDataModal, setOBTRejectReasonDataModal] = useState(false);
  const [obtRejectReason, setOBTRejectReason] = useState([]);
  const [selectedOBTStatusData, setSelectedOBTStatusData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [chaptlist, setchaplist] = useState([]);
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0,
    chpt_id: 0,
    obt_status: -1,
    searchmember: "",
    ratings: 0,
    startDate: null,
    endDate: null
  });
  const [obtData, setOBTData] = useState([]);
  const [newOBTData, setNewOBTData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [obtDataAll, setOBTDataAll] = useState([]); // for full OBT data

  const [QuestionAnswerModalData, setQuestionAnswerModalData] = useState(false);
  const [obtQuestionAnswerList, setOBTQuestionAnswerList] = useState([]);
  const [qaExportData, setQAExportData] = useState([]);
  const csvLinkRef = useRef(); // for triggering CSVLink

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  // Open modal with obt ID
  const openApproveRejectModal = async (obtData) => {
    setSelectedOBTStatusData({
      ...obtData,
      status: obtData?.obt_status // Save current status
    });

    if (obtData?.obt_status === 1) {
      const matchedReason = obtRejectReason.find((r) => r.obt_r_id === obtData?.obt_reject_reason);

      if (matchedReason) {
        setRejectReason({
          id: matchedReason.obt_r_id,
          title: matchedReason.obt_reject_reason
        });
      } else {
        setRejectReason({ id: "", title: "" }); // fallback if not found
      }
    } else {
      setRejectReason({ id: "", title: "" }); // clear
    }

    setOBTRejectReasonDataModal(true); // Open modal
  };

  // Close modal and reset state
  const closeModal = () => {
    setOBTRejectReasonDataModal(false);
    setQuestionAnswerModalData(false);
  };

  const getOBTRejectReasonData = async () => {
    let res = await getOBTRejectReason();
    setOBTRejectReason(res);
  };

  const handleCSVExportWithQA = async () => {
    const allExportData = await Promise.all(
      newOBTData.map(async (row) => {
        const statusLabel =
          row.obt_status === 2 ? "Approved" : row.obt_status === 1 ? "Rejected" : "Pending";

        const base = {
          No: row.o_a_id,
          "Member Name": row.m_name,
          "Chapter Name": row.chpt_name,
          "Apply Date": row.obt_apply_date || "-",
          Rating: row.obt_ratings || "-",
          "Approve Date": row.obt_approve_date || "-",
          "Approved By": row.approve_by_name || "-",
          Status: statusLabel,
          "Reject Reason": row.obt_reject_reason_title || "-"
        };

        let qaText = "No Question Answer";

        try {
          setIsLoading(true);
          const qaRes = await getOBTQuestionAnswer(row.o_a_id);
          setIsLoading(false);
          if (qaRes.status === 1) {
            qaText = qaRes.data
              .map((qa) => `${qa.obt_question}: ${qa.obt_ans === 1 ? "Yes" : "No"}`)
              .join(" | ");
          }
        } catch (error) {
          qaText = "Error loading QA";
        }

        const tabFields =
          selectedTab === 0
            ? {
                "Start Image URL": row.obt_start_img
                  ? `${Routes.API_HOSTNAME}images/obt_apply/${row.obt_start_img}`
                  : "-",
                "End Image URL": row.obt_end_img
                  ? `${Routes.API_HOSTNAME}images/obt_apply/${row.obt_end_img}`
                  : "-",
                "OBT Title": row.obt_title || "-"
              }
            : {
                "Offline Taken By": row.obt_offline_taken_by || "-",
                "Offline Image URL": row.obt_offline_img
                  ? `${Routes.API_HOSTNAME}images/obt_apply/${row.obt_offline_img}`
                  : "-",
                "Offline Attend Date": row.obt_offline_date || "-"
              };

        return {
          ...base,
          ...tabFields,
          "Question/Answer": qaText
        };
      })
    );

    setQAExportData(allExportData);

    // Trigger CSV download
    setTimeout(() => {
      csvLinkRef.current.link.click();
    }, 0);
  };

  const columns = [
    {
      name: "No",
      selector: (row) => row.o_a_id,
      wrap: true,
      width: "100px",
      sortable: true
    },
    {
      name: "Member Name",
      selector: (row) => row.m_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Chapter Name",
      selector: (row) => row.chpt_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Apply Date",
      selector: (row) => row.obt_apply_date,
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Rating",
      selector: (row) => renderStars(row?.obt_ratings), // Unicode-based stars
      sortable: true,
      width: "120px"
    },
    ...(selectedTab === 0
      ? [
          // Online tab (obt_type = 0)
          {
            name: "OBT Start Image",
            cell: (row) =>
              row.obt_start_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_start_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_start_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "OBT End Image",
            cell: (row) =>
              row.obt_end_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_end_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_end_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "OBT Title",
            cell: (row) => {
              const content = row.obt_title ?? "-";
              return (
                <div title={content}>
                  {content.length > 30 ? content.slice(0, 30) + "..." : content}
                </div>
              );
            },
            sortable: true,
            width: "150px",
            wrap: false
          },
          {
            name: "OBT Start Date",
            selector: (row) => row.obt_sdate,
            sortable: true,
            width: "110px",
            wrap: true
          },
          {
            name: "OBT End Date",
            selector: (row) => row.obt_edate,
            sortable: true,
            width: "110px",
            wrap: true
          }
        ]
      : [
          // Offline tab (obt_type = 1)
          {
            name: "Offline OBT Taken By",
            selector: (row) => row.obt_offline_taken_by,
            sortable: true,
            wrap: true
          },
          {
            name: "Offline OBT Image",
            cell: (row) =>
              row.obt_offline_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_offline_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/obt_apply/${row.obt_offline_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "Offline OBT Attend Date",
            selector: (row) => row.obt_offline_date,
            sortable: true,
            wrap: true
          }
        ]),
    {
      name: "Approve Date",
      selector: (row) => (row.obt_approve_date ? row.obt_approve_date : "-"),
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Approve/ Rejected By",
      selector: (row) => (row.approve_by_name ? row.approve_by_name : "-"),
      sortable: true,
      width: "100px",
      wrap: true
    },
    {
      name: "Status",
      wrap: false,
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.obt_status == 2 ? "success" : row.obt_status == 1 ? "error" : "warning"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.obt_status == 2 ? "Approved" : row.obt_status == 1 ? "Rejected" : "Pending"}
        </Label>
      ),
      sortable: false
    },
    {
      name: "Approve/ Reject",
      width: "90px",
      cell: (row) => (
        <>
          <Tooltip title="Approve/Reject OBT">
            <IconButton onClick={() => openApproveRejectModal(row)}>
              <ReplayCircleFilledOutlined color="success" />
            </IconButton>
          </Tooltip>
        </>
      )
    },
    {
      name: "OBT Question/ Answer",
      width: "90px",
      cell: (row) => (
        <>
          <Tooltip title="OBT Question/ Answer">
            <IconButton onClick={() => openQuestionAnswerModal(row.o_a_id)}>
              <RemoveRedEye color="info" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      obt_status: -1,
      searchmember: "",
      ratings: 0,
      startDate: null,
      endDate: null
    });
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  useEffect(async () => {
    getallcitylist();
    getOBTRejectReasonData();
  }, []);

  const handleSubmitOBTStatus = async () => {
    if (!selectedOBTStatusData?.status && selectedOBTStatusData?.status !== 0) {
      notification({ type: "error", message: "Please select a status." })();
      return;
    }

    if (selectedOBTStatusData.status === 1 && !rejectReason.id) {
      notification({ type: "error", message: "Please select a reject reason." })();
      return;
    }

    const payload = {
      o_a_id: selectedOBTStatusData?.o_a_id,
      m_id: selectedOBTStatusData?.m_id,
      obt_status: selectedOBTStatusData?.status,
      obt_approve_by: loginUser?.u_id,
      obt_reject_reason: selectedOBTStatusData?.status == 1 ? rejectReason.id : null,
      obt_reject_reason_title: selectedOBTStatusData?.status == 1 ? rejectReason.title : null
    };
    try {
      setIsLoading(true);
      const res = await obtApproveReject(payload);
      setIsLoading(false);
      if (res?.status === 1) {
        let notify = notification({
          type: "success",
          message: res.message
        });
        notify();
        await GetOBTData();
      } else {
        let notify = notification({
          type: "error",
          message: res.message
        });
        notify();
      }
    } catch (err) {
      let notify = notification({
        type: "success",
        message: "Something went wrong!"
      });
      notify();
    }

    // Cleanup
    setOBTRejectReasonDataModal(false);
    setRejectReason({ id: "", title: "" });
    setSelectedOBTStatusData(null);
  };

  const filterData = () => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (searchdata?.city_id != 0) {
            if (chpt?.city_id == searchdata?.city_id) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    const OBTList =
      obtDataAll &&
      obtDataAll.filter((obt) => {
        if (parseInt(obt.obt_type) !== selectedTab) return false;

        const obtDate = obt.obt_apply_date
          ? moment(obt.obt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        const startDate = searchdata.startDate ? new Date(searchdata.startDate) : null;
        const endDate = searchdata.endDate ? new Date(searchdata.endDate) : null;

        let dateMatch = true;
        if (startDate && endDate && obtDate) {
          obtDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          dateMatch = obtDate >= startDate && obtDate <= endDate;
        }

        if (
          (obt.chpt_id == searchdata?.chpt_id || searchdata?.chpt_id == 0) &&
          selectedCityChapter.length != 0 &&
          selectedCityChapter.includes(obt.chpt_id) &&
          (searchdata.obt_status === -1
            ? [0, 1, 2].includes(obt.obt_status)
            : obt.obt_status === searchdata.obt_status) &&
          (searchdata.ratings === 0 ||
            parseInt(obt.obt_ratings) === parseInt(searchdata.ratings)) &&
          dateMatch &&
          (obt.m_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            obt.business_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            obt.business_category.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            obt.mobile_no.toLowerCase().includes(searchdata?.searchmember.toLowerCase()))
        ) {
          return obt;
        }
      });

    setNewOBTData(OBTList);
  };

  const isFilterApplied = () => {
    return (
      searchdata.city_id !== 0 ||
      searchdata.chpt_id !== 0 ||
      searchdata.obt_status !== -1 ||
      searchdata.searchmember.trim() !== "" ||
      searchdata.ratings !== 0 ||
      searchdata.startDate !== null ||
      searchdata.endDate !== null
    );
  };

  // useEffect(() => {
  //   filterData();
  // }, [searchdata, obtData, selectedTab]);

  useEffect(() => {
    if (!isFilterApplied()) {
      // show only 1 month if no filters are applied
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      const filteredRecent = obtDataAll.filter((item) => {
        const applyDate = item.obt_apply_date
          ? moment(item.obt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        return applyDate && applyDate >= oneMonthAgo && parseInt(item.obt_type) === selectedTab;
      });

      setNewOBTData(filteredRecent);
    } else {
      filterData(); // run filter on full data
    }
  }, [searchdata, obtDataAll, selectedTab]);

  // const GetOBTData = async () => {
  //   let res = await getOBTApplyList(loginUser.city_id, loginUser.u_type);
  //   if (res?.data?.length > 0) {
  //     setOBTData(res?.data);
  //   } else {
  //     setOBTData([]);
  //   }
  // };

  const GetOBTData = async () => {
    setIsLoading(true);
    let res = await getOBTApplyList(loginUser.city_id, loginUser.u_type);
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setOBTDataAll(res?.data); // full data for filtering

      // show only 1 month data on initial load
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      const filteredRecent = res.data.filter((item) => {
        const applyDate = item.obt_apply_date
          ? moment(item.obt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        return applyDate && applyDate >= oneMonthAgo;
      });

      setOBTData(filteredRecent); // initial visible data
    } else {
      setOBTData([]);
      setOBTDataAll([]);
    }
  };

  useEffect(async () => {
    GetOBTData();
  }, []);

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.obt_desc != null && data?.obt_desc != "" && (
          <p>
            <b>Description</b> : {data?.obt_desc}
          </p>
        )}
        {data?.obt_reject_reason_title != null && data?.obt_reject_reason_title != "" && (
          <p>
            <b>Reject Reason</b> : {data?.obt_reject_reason_title}
          </p>
        )}
        {data?.obt_reject_date != null && data?.obt_reject_date != "" && (
          <p>
            <b>Rejected Date</b> : {data?.obt_reject_date}
          </p>
        )}
      </div>
    );
  };

  const openQuestionAnswerModal = async (o_a_id) => {
    setQuestionAnswerModalData(true); // Open modal

    try {
      const resp = await getOBTQuestionAnswer(o_a_id);
      if (resp.status === 1) {
        setOBTQuestionAnswerList(resp.data);
      } else {
        setOBTQuestionAnswerList([]);
      }
    } catch (error) {
      console.error("Error fetching Attachment data:", error);
    }
  };

  return (
    <>
      <Page title="OBT Member Requests | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              OBT Member Requests
            </Typography>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>OBT Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      obtApproveRejectOptions &&
                      obtApproveRejectOptions.map((option) => {
                        if (option.value == searchdata.obt_status) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, obt_status: e.value });
                    }}
                    options={
                      obtApproveRejectOptions &&
                      obtApproveRejectOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Ratings</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberRatings.map((c) => {
                      if (c.value == searchdata.ratings) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        ratings: e.value
                      });
                    }}
                    options={memberRatings}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select OBT Apply Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.startDate != null ? searchdata.startDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <label>Select OBT Apply End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.endDate != null ? searchdata.endDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    name="search"
                    size="small"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid xs={1} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px", padding: "15px 10px" }}>
            {obtData && (
              <>
                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Button
                        variant={selectedTab === 0 ? "contained" : "outlined"}
                        onClick={() => setSelectedTab(0)}
                        style={{ marginRight: 10 }}
                      >
                        Online OBT Requests
                      </Button>
                      <Button
                        variant={selectedTab === 1 ? "contained" : "outlined"}
                        onClick={() => setSelectedTab(1)}
                      >
                        Offline OBT Requests
                      </Button>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "right" }}>
                      <Button
                        onClick={handleCSVExportWithQA}
                        variant="contained"
                        style={{ marginBottom: 10 }}
                        disabled={isLoading}
                        startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                      >
                        Export CSV
                      </Button>
                      <CSVLink
                        data={qaExportData}
                        filename={`OBT_${selectedTab === 0 ? "Online" : "Offline"}_Requests.csv`}
                        className="d-none"
                        ref={csvLinkRef}
                      />
                    </Grid>
                  </Grid>
                </Stack>

                <DataTable
                  key={selectedTab}
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newOBTData != null ? newOBTData : []}
                  expandableRows
                  expandableRowsComponent={ExpandableRow}
                  expandableRowDisabled={(row) => !row?.obt_desc && !row?.obt_reject_reason}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        {/* OBT Approve/Reject Modal */}
        <Modal
          open={obtRejectReasonDataModal}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={obtDetailModalStyle}>
            <Typography variant="h6" textAlign="center" style={{ marginBottom: "20px" }}>
              Approve/Reject OBT
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 1300 })
                  }}
                  onChange={(e) => {
                    setSelectedOBTStatusData((prev) => ({
                      ...prev,
                      status: e.value
                    }));
                    if (e.value !== 1) {
                      setRejectReason({ id: "", title: "" }); // reset reject reason if not rejected
                    }
                  }}
                  value={
                    obtApproveRejectOptions.find(
                      (option) => option.value === selectedOBTStatusData?.status
                    ) || null
                  }
                  options={obtApproveRejectOptions
                    ?.filter((reasons) => reasons?.value != -1)
                    .map((reasons) => ({
                      label: reasons?.label,
                      value: reasons?.value
                    }))}
                />
              </Grid>
              {selectedOBTStatusData?.status === 1 && (
                <Grid item xs={12}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 1300 })
                    }}
                    onChange={(e) => {
                      setRejectReason({ id: e.value, title: e.label });
                    }}
                    value={
                      rejectReason?.id
                        ? { value: rejectReason.id, label: rejectReason.title }
                        : null
                    }
                    options={obtRejectReason?.map((reasons) => ({
                      label: reasons?.obt_reject_reason,
                      value: reasons?.obt_r_id
                    }))}
                  />
                </Grid>
              )}
            </Grid>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={handleSubmitOBTStatus}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={closeModal}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Question/Answer Modal */}
        <Modal
          open={QuestionAnswerModalData}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={QuestionAnswerModalStyle}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 1, textAlign: "center" }}
            >
              OBT Question/Answer
            </Typography>
            <hr />

            <Stack sx={{ my: 2 }}>
              {obtQuestionAnswerList.length > 0 ? (
                <Table
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    overflow: "hidden"
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>
                        <b>Question</b>
                      </TableCell>
                      <TableCell>
                        <b>Answer</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {obtQuestionAnswerList.map((datalist, index) => (
                      <TableRow key={index}>
                        <TableCell>{datalist.obt_question}</TableCell>
                        <TableCell>{datalist.obt_ans === 1 ? "Yes" : "No"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", mt: 1, fontStyle: "italic" }}
                >
                  No Question Answer
                </Typography>
              )}
            </Stack>

            <hr />
            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              <Button variant="outlined" onClick={closeModal}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
